"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  position: relative;\n  .ant-slider {\n    .ant-slider-rail,\n    .ant-slider-track {\n      transition: transform 0.25s ease-in-out;\n    }\n    .ant-slider-rail {\n      background: rgba(255, 255, 255, 30%);\n      &::before {\n        display: block;\n        content: ' ';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: ", "%;\n        border-radius: 10px;\n        background: rgba(255, 255, 255, 30%);\n      }\n    }\n    .ant-slider-track {\n      background: rgba(255, 255, 255, 90%);\n      border-radius: 10px;\n    }\n    .ant-slider-step {\n      display: none;\n    }\n    .ant-slider-handle {\n      background-color: white;\n      border: none;\n      transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;\n      transform: translateX(-50%) scale(0.5) !important;\n      box-shadow: none;\n      opacity: 0;\n      z-index: 100;\n    }\n  }\n  &:hover .ant-slider {\n    .ant-slider-rail,\n    .ant-slider-track {\n      transform: scaleY(1.5) !important;\n    }\n    .ant-slider-handle {\n      transform: translateX(-50%) scale(1) !important;\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var web_1 = require("@thesisedu/web");

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var MediaPlaybackContext_1 = require("./MediaPlaybackContext");

var SliderContainer = web_1.styled.div(_templateObject(), function (props) {
  return props.loadedPercentage * 100;
});
var DEBOUNCE = 500;

function Track(_ref) {
  var children = _ref.children;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      loadedPercentage = _ref2.loadedPercentage,
      duration = _ref2.duration,
      onSeek = _ref2.onSeek,
      allowSeek = _ref2.allowSeek,
      playedSeconds = _ref2.playedSeconds;

  var _ref3 = (0, react_1.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      localValue = _ref4[0],
      setLocalValue = _ref4[1];

  var timeout = (0, react_1.useRef)();
  (0, react_1.useEffect)(function () {
    if (!timeout.current) {
      setLocalValue(playedSeconds);
    }
  }, [playedSeconds]);
  return react_1.default.createElement(SliderContainer, {
    loadedPercentage: loadedPercentage,
    className: 'track'
  }, duration ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(antd_1.Slider, {
    onChange: function onChange(value) {
      setLocalValue(value);

      if (timeout.current) {
        clearInterval(timeout.current);
        timeout.current = undefined;
      }

      timeout.current = setTimeout(function () {
        onSeek(value);
        timeout.current = undefined;
      }, DEBOUNCE);
    },
    tipFormatter: null,
    max: duration,
    min: 0,
    step: 0.25,
    value: localValue,
    disabled: !allowSeek
  }), children) : null);
}

exports.Track = Track;